<template>
  <div>
    <template v-if="listings.results">
      <template v-if="listings.count">
        <listing-basic
          v-for="listing of listings.results"
          :key="`listing${listing.id}`"
          :listing="listing"
        />
      </template>
      <p v-else>
        There are no listings for auction.
      </p>
    </template>
    <spinner
      v-else-if="listings.loading"
      preset="large"
    />
    <template v-else-if="listings.error">
      <div
        class="alert alert-danger"
        role="alert"
      >
        An error occurred while trying to load the listings. Please check your
        connection and try again.
      </div>

      <button
        type="button"
        class="btn btn-outline-primary"
        @click="loadListings"
      >
        Try Again
      </button>
    </template>
  </div>
</template>

<script>
import ListingBasic from '@/components/ListingBasic.vue';

export default {
  metaInfo: {
    title: 'For Auction',
  },
  components: {
    ListingBasic,
  },
  data() {
    return {
      listings: { loading: true },
    };
  },
  created() {
    this.loadListings();
  },
  methods: {
    async loadListings() {
      this.listings = { loading: true };

      // BEGIN FAKE CODE -- TODO: REPLACE WITH REAL CODE
      await new Promise(resolve => setTimeout(resolve, 1000));
      // this.listings = { error: true };
      this.listings = {
        count: 1,
        results: [
          {
            id: 1,
            user: {
              id: 1,
              first_name: 'Edward',
              last_name: 'Smith',
              avatar_url: 'https://s3.amazonaws.com/uifaces/faces/twitter/glif/128.jpg',
            },
            price: 12345.5,
            // If auction_end has a value, the listing is an auction. If it
            // is null, it is not an auction.
            auction_end: '2020-02-23T01:23:45.123456Z',
            title: 'Testing the "For Auction" Page',
            description: 'Foo',
            images: [
              { url: 'https://via.placeholder.com/1024x768', caption: '' },
              { url: 'https://via.placeholder.com/800x600', caption: '' },
              { url: 'https://via.placeholder.com/640x480', caption: '' },
              { url: 'https://via.placeholder.com/320x240', caption: '' },
            ],
            location: {
              city_name: 'St. George',
            },
            total_comments: 10,
            total_likes: 2,
            total_views: 20,
            created: '2020-01-23T01:23:45.123456Z',
            comments: {
              results: [],
            },
          },
        ],
      };
      // END FAKE CODE
    },
  },
};
</script>
